// extracted by mini-css-extract-plugin
module.exports =  {"bpSmMin":"0","bpMdMin":"750px","bpDtMin":"1024px","bpDtLMin":"1440px","bpDtXLMin":"1920px","grid":"grid__grid___paGry","resetSpaceLR":"grid__resetSpaceLR___wFZZG"};